var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1801 4.71006L21.0801 3.81006L22.1801 1.41006L19.6201 2.26006C18.8047 1.49999 17.7347 1.072 16.6201 1.06006C14.1371 1.06556 12.1256 3.07706 12.1201 5.56006V6.56006C8.58008 7.29006 5.49008 5.36006 2.62008 2.06006C2.12008 4.72673 2.62008 6.72673 4.12008 8.06006L0.830078 7.56006C1.0924 9.74603 2.88223 11.4306 5.08008 11.5601L2.33008 12.5601C3.33008 14.5601 5.15008 14.8701 7.58008 15.0601C5.5939 16.4147 3.23365 17.1141 0.830078 17.0601C13.5901 22.7301 21.0801 14.4001 21.0801 7.06006V6.23006L23.1801 4.71006Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.154dde6b93fd643ad648f938ae935d6c.svg";
export { ForwardRef as ReactComponent };